import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import "./assets/css/line-awesome.min.css";
import "./assets/css/material.css";
import "./assets/scss/main.scss";
import { AuthProvider } from "./context/AuthContext";
import Approuter from "./Routes/Approuter";
import CheckoutOnTabCloseGuard from "./hooks/useCheckoutOnTabClose";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <CheckoutOnTabCloseGuard />
    <Approuter />
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 3000,
        style: { zIndex: 9999 },
      }}
    />
  </AuthProvider>
);

serviceWorkerRegistration.register();
